import * as types from './types';

export const setPortability = ({ commit }, payload) => {
  commit(types.SET_PORTABILITY, payload);
};

export const setAddicionalNumbers = ({ commit }, payload) => {
  commit(types.SET_ADDICIONAL_NUMBERS, payload);
};

export const updateAdditionalPlanValue = ({ commit }, payload) => {
  commit(types.UPDATE_ADDITIONAL_PLAN_VALUE, payload);
};

export const updateMovelNumberPortabilityInfo = ({ commit }, payload) => {
  commit(types.UPDATE_PORTABILITY_INFO_VALUE, payload);
};

export const setAvailableNumbers = ({ commit }, payload) => {
  commit(types.SET_AVAILABLE_NUMBERS, payload);
};

export const setChosenNumber = ({ commit }, payload) => {
  commit(types.SET_CHOSEN_NUMBER, payload);
};

export const setPaymentEntity = ({ commit }, payload) => {
  commit(types.SET_PAYMENT_ENTITY, payload);
};

export const setPaymentRef = ({ commit }, payload) => {
  commit(types.SET_PAYMENT_REF, payload);
};

export const setPaymentTotal = ({ commit }, payload) => {
  commit(types.SET_PAYMENT_TOTAL, payload);
};

export const setLastSessionId = ({ commit }, payload) => {
  commit(types.SET_LAST_SESSION_ID, payload);
};

export default {
  setPortability,
  setAddicionalNumbers,
  updateAdditionalPlanValue,
  updateMovelNumberPortabilityInfo,
  setAvailableNumbers,
  setChosenNumber,
  setPaymentEntity,
  setPaymentRef,
  setPaymentTotal,
  setLastSessionId
};



// WEBPACK FOOTER //
// ./src/store/modules/movel/actions.js